// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "styles" + "." + "b5ee7b88d81ac17de3a1" + ".css";
};